/**
 * @generated SignedSource<<5314fb97f0342ba502f04636fec0d2f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type DeleteGeneralAssetFamilyInput = {
  generalAssetFamilyId: string;
  clientMutationId?: string | null;
};
export type GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation$variables = {
  input: DeleteGeneralAssetFamilyInput;
};
export type GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutationVariables = GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation$variables;
export type GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation$data = {
  readonly deleteGeneralAssetFamily: {
    readonly generalAssetFamily: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly message: string;
    }>;
  } | null;
};
export type GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutationResponse = GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation$data;
export type GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation = {
  variables: GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutationVariables;
  response: GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteGeneralAssetFamilyPayload",
    "kind": "LinkedField",
    "name": "deleteGeneralAssetFamily",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralAssetFamily",
        "kind": "LinkedField",
        "name": "generalAssetFamily",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "669f3ec3d09c2b0f66ac2e62a58ebdae",
    "id": null,
    "metadata": {},
    "name": "GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation",
    "operationKind": "mutation",
    "text": "mutation GeneralAssetFamiliesTableDeleteGeneralAssetFamilyMutation(\n  $input: DeleteGeneralAssetFamilyInput!\n) {\n  deleteGeneralAssetFamily(input: $input) {\n    generalAssetFamily {\n      id\n      name\n    }\n    errors {\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4c175a79effa0df7dd7ad261842554e";

export default node;
